// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<div id='customer-loans-check-payment' class="box">
    <form name="\$ctrl.form">
      <sub-header header="'Cash payment'" ></sub-header>

      <amortization-payment
        loan="\$ctrl.loan"
        payment-request="\$ctrl.paymentRequest"
        collect-official-receipt="true"
        custom-payment-allowed="\$ctrl.canPerformCustomPayment"
        ng-form="\$ctrl.amortizationForm"
      >
      </amortization-payment>

      <div class="buttons">
        <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button type="button" class="btn btn-print" ng-click="\$ctrl.print()">Print</button>
        <button type="button" class="btn btn-success" ng-disabled="\$ctrl.form.\$invalid || !\$ctrl.loan" ng-click="\$ctrl.pay()">
          Confirm payment
        </button>
      </div>

    </form>

</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/cash-payment/loan-cash-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;